import * as XLSX from 'xlsx';
// 定义 ID 列表
const ELECTRIC_IDS = [1, 3, 5, 7, 9, 11, 13, 15, 16, 18, 21, 26, 30, 42, 43, 46, 48];
const WATER_IDS = [2, 4, 6, 8, 10, 12, 14, 17, 19, 20, 22, 23, 24, 27, 28, 31, 32, 35, 36, 37, 38, 39, 40, 41, 44, 45,
	47, 49
];

/**
 * 获取设备类型
 * @param {Number|String} id - 当前行的 deviceId
 * @returns {String} '电表' | '水表' | '未知'
 */
export function getDeviceType(id) {
	// 统一转为数字比较，防止 "1" !== 1
	const numId = Number(id);

	if (ELECTRIC_IDS.includes(numId)) return '电表';
	if (WATER_IDS.includes(numId)) return '水表';

	return '未知';
}


export function formatDateTime(date) {
  // 1. 如果传入的不是 Date 对象，尝试将其转换为 Date 对象
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  // 2. 检查转换后的 Date 是否有效（防止传入了 'abc' 或 NaN 导致变成 Invalid Date）
  if (isNaN(date.getTime())) {
    return ''; // 或者返回 '--'，看你的业务需求
  }

  // 3. 安全地获取年月日时分秒
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 🚀 统一 Excel 导出入口
 * @param {ExportOptions} options
 * @returns {Promise<void>}
 */
export async function exportExcel(options) {
  const {
    fileName,
    sheetName = 'Sheet1',
    maxSafeRows = '50000',
    onProgress,
  } = options;

  try {
    let data;

    // ========== 阶段1：获取数据 ==========
    // 静态数据模式
    data = options.data;
    onProgress?.({
      loaded: data.length,
      total: data.length,
      percent: 100,
      stage: 'fetching',
      message: '数据已就绪',
    });

    // ========== 阶段2：安全校验 ==========
    if (data.length === 0) {
      onProgress?.({ loaded: 0, total: 0, percent: 100, stage: 'done', message: '无数据可导出' });
      alert('暂无数据可导出');
      return;
    }

    if (data.length > maxSafeRows) {
      const confirmExport = window.confirm(
        `当前数据量 ${data.length} 条，超过推荐上限 ${maxSafeRows} 条，可能导致浏览器卡顿或崩溃。\n是否继续导出？`
      );
      if (!confirmExport) return;
    }

    // ========== 阶段3：生成并下载文件 ==========
    onProgress?.({
      loaded: data.length,
      total: data.length,
      percent: 90,
      stage: 'generating',
      message: '正在生成 Excel 文件...',
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);

    onProgress?.({
      loaded: data.length,
      total: data.length,
      percent: 100,
      stage: 'done',
      message: '✅ 导出完成',
    });
  } catch (err) {
    console.error('[ExcelExporter] 导出失败:', err);
    const message = err instanceof Error ? err.message : String(err);
    onProgress?.({ loaded: 0, total: 0, percent: 0, stage: 'error', message: `导出失败: ${message}` });
    alert(`导出失败: ${message}`);
  }
}

/**
 * 时间段工具
 * 返回已格式化的字符串（直接复用本文件里的 formatDateTime），格式：YYYY-MM-DD HH:mm:ss
 * 区间为闭区间：开始 00:00:00，结束 23:59:59。
 * 注意：全部用本地时区方法（getFullYear/getMonth），不要用 toISOString()，否则东八区会差 8 小时。
 */

/** 今日 */
export function getTodayRange() {
  const now = new Date();
  return {
    startTime: formatDateTime(new Date(now.getFullYear(), now.getMonth(), now.getDate())),
    endTime: formatDateTime(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999))
  };
}

/** 本月 */
export function getCurrentMonthRange() {
  const now = new Date();
  return {
    startTime: formatDateTime(new Date(now.getFullYear(), now.getMonth(), 1)),
    // 次月 0 号 = 本月最后一天，自动处理大小月和跨年
    endTime: formatDateTime(new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999))
  };
}

/** 上月 */
export function getLastMonthRange() {
  const now = new Date();
  return {
    startTime: formatDateTime(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
    endTime: formatDateTime(new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999))
  };
}